// extracted by mini-css-extract-plugin
export var messageSideLeft = "_p0-1";
export var messageSideRight = "_p0-2";
export var subscribeToBackInStockBubbleContainer = "_p0-0";